export const HIGH_SCORE_FONT_WEIGHT = 600;
export const OTHER_SCORE_FONT_WEIGHT = 400;
export const TWO_FRACTION_DIGITS = 2;
